import { render } from "./CreateAssurance.vue?vue&type=template&id=a22e1e26&scoped=true"
import script from "./CreateAssurance.vue?vue&type=script&lang=js"
export * from "./CreateAssurance.vue?vue&type=script&lang=js"

import "./CreateAssurance.vue?vue&type=style&index=0&id=a22e1e26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22e1e26"]])

export default __exports__